export default __webpack_public_path__ + "static/media/vkr.06d30ae6.svg";